<ion-text class="input-error" *ngIf="errors">
  <small *ngFor="let error of errors">
    {{ error }}
  </small>
</ion-text>
